import {
  Fab, Zoom,
  // CircularProgress
} from "@mui/material";
import { useEffect, useState, lazy, Suspense } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

// Static imports (needed immediately)
import Header from "../../Header.tsx";
import Footer from "../../Footer.tsx";
import "../../../styles/HomePage.scss";

// Lazy-loaded sections (post-hero or below-the-fold)
const BannerVideoSlider = lazy(() => import("./bannerVideoSlider.tsx"));
const WorkFlow = lazy(() => import("./workFlow.tsx"));
const WhatWillDo = lazy(() => import("./whatWillDo.tsx"));
const Advantage = lazy(() => import("./advantages.tsx"));
const Features = lazy(() => import("./features.tsx"));
const OurExperts = lazy(() => import("./ourExperts.tsx"));
const WhatWeOffer = lazy(() => import("./whatWeOffer.tsx"));
const StartFreeTrial = lazy(() => import("./startFreetrail.tsx"));

const PreloginHome = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const duration = 1000;
    const start = window.scrollY;
    const startTime = performance.now();

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 1);

      window.scrollTo(0, start * (1 - ease));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  // const FallbackLoader = (
  //   <div style={{ textAlign: "center", padding: "40px 0" }}>
  //     <CircularProgress size={32} color="primary" />
  //   </div>
  // );

  return (
    <>
      {/* Hero Video Section */}
      <Suspense>
        <Header />
        <BannerVideoSlider />
      </Suspense>

      {/* Scroll To Top Button */}
      <Zoom in={showButton}>
        <Fab
          color="primary"
          size="medium"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 15,
            zIndex: 1300,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
          aria-label="Scroll back to top"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </Zoom>

      {/* Below-the-fold Sections (Lazy Loaded) */}
      <Suspense>
        <WorkFlow />
        <WhatWillDo />
        <Advantage />
        <Features />
        <OurExperts />
        <WhatWeOffer />
        <StartFreeTrial />
        <Footer />
      </Suspense>
    </>
  );
};

export default PreloginHome;
